import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("my_tasks.download_metadata"))),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0",
                attrs: { items: _vm.getBreadcrumbs },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: {
                    color: _vm.isButtonDownloadHidden ? "primary" : "",
                    outlined: "",
                    dense: "",
                    disabled:
                      !_vm.isButtonDownloadHidden || !_vm.detail_tables_load,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.dialogConfirmation.onOpen()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("icon-download"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("my_tasks.download_metadata"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: {
                    color: "primary",
                    outlined: "",
                    disabled: _vm.isLoadingTables,
                    loading: _vm.isLoadingTables,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.dialogDownloadProd.onOpen()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("mdi-file-excel"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("my_tasks.download_prod"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("btns.filter"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.filter_enabled
        ? _c(
            VCard,
            { staticClass: "d-block d-md-none mb-2" },
            [
              _c(VCardTitle, { staticClass: "pointer" }, [
                _vm._v(_vm._s(_vm.$t("my_tasks.search_filters"))),
              ]),
              _c(
                VCardText,
                { staticClass: "pa-2" },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      !_vm.isEmptyTable
                        ? _c("search-in-table-new", {
                            attrs: {
                              withConditions: false,
                              showDomains: _vm.isDomainItc,
                              showSynapse: _vm.isSynapseActive,
                            },
                            on: { submit: _vm.sendToSearch },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _vm.queryResponse && _vm.queryResponse.tables
              ? _c(
                  VCard,
                  [
                    _c(
                      VCardText,
                      { staticClass: "pa-0" },
                      [
                        _c(VDataTable, {
                          key: _vm.key_table,
                          staticClass: "table-inca",
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.queryResponse.tables,
                            "show-select": "",
                            "disable-pagination": "",
                            "hide-default-footer": "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.enterSelect()
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "item.tableReference.tableId",
                                fn: function (row) {
                                  return [
                                    _c("div", { staticClass: "text-left" }, [
                                      _c("b", { staticClass: "table-name" }, [
                                        _vm._v(
                                          _vm._s(
                                            row.item.tableReference.tableId
                                          )
                                        ),
                                      ]),
                                      _c("br"),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "compose-name",
                                          attrs: { title: row.item.id },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("joinTableReference")(
                                                row.item.tableReference
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.creationTime",
                                fn: function (row) {
                                  return [
                                    _c("a", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            row.item.creationTime
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.numRows",
                                fn: function (row) {
                                  return [
                                    _c("span", { staticClass: "date-format" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            row.item.numRows
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3720409396
                          ),
                          model: {
                            value: _vm.selected,
                            callback: function ($$v) {
                              _vm.selected = $$v
                            },
                            expression: "selected",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(
                      VCardTitle,
                      {
                        staticClass: "pointer",
                        on: {
                          click: function ($event) {
                            _vm.collapse_filter = !_vm.collapse_filter
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("my_tasks.search_filters")))]
                    ),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        !_vm.isEmptyTable
                          ? _c("search-in-table-new", {
                              attrs: {
                                withConditions: false,
                                showDomains: _vm.isDomainItc,
                                showAllFilter: false,
                                showSynapse: _vm.isSynapseActive,
                              },
                              on: { submit: _vm.sendToSearch },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("pagination-catalog", {
        key: _vm.key_pagination,
        attrs: { pagination: _vm.pagination },
        on: { changePagina: _vm.changePagina },
      }),
      _c("dialog-confirmation-component", {
        ref: "dialogConfirmation",
        attrs: {
          title: _vm.$t("my_tasks.confirm_full"),
          text: _vm.$t("my_tasks.want_full"),
        },
        on: { onConfirm: _vm.onConfirm },
      }),
      _c("dialog-confirmation-component", {
        ref: "dialogDownloadProd",
        attrs: {
          title: _vm.$t("my_tasks.confirm_full"),
          text: _vm.$t("my_tasks.want_full"),
        },
        on: { onConfirm: _vm.downloadExcelProdTables },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }